import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { ROUTES } from "config";

export default function RequirePermission({
    requiredPermissions = [],
    children
}) {
    const permissions = useSelector((state) => state.user.permissions);
    const hasAccess =
        requiredPermissions.includes("all") ||
        requiredPermissions.length === 0 ||
        requiredPermissions.some((p) => permissions?.includes(p));

    if (!hasAccess) {
        return <Navigate to={ROUTES.DASHBOARD} replace />;
        // or render a <Forbidden /> page instead of redirecting
    }

    return children;
}
